export const ProductColumns = [
  {
    id: "actions",
    title: "Actions",
    type: "product",
  },
  {
    id: "code",
    title: "Item Code",
  },
  {
    id: "name",
    title: "Item Name",
    type: "item",
  },
  {
    id: "companyId",
    title: "Company",
  },
  {
    id: "unit",
    title: "Unit",
  },
  {
    id: "purchase",
    title: "Cost",
  },
  {
    id: "sale",
    title: "Price",
  },
  {
    id: "sale_shop",
    title: "Dealer Price",
  },
  {
    id: "in_qty",
    title: "In-Quantity",
  },
  {
    id: "opening_qty",
    title: "Opening-Quantity",
  },
  {
    id: "out_qty",
    title: "Out-Quantity",
  },
  {
    id: "qty",
    title: "Quantity",
  },
];
